import styled, { css, keyframes } from 'styled-components';
import { CalciteCard, CalciteLabel } from './Calcite';
import { unitCalc } from 'utils/cssUtils';

export const Heading = styled.div`
  color: ${({ theme }) => theme.color.text1};
  font-size: ${({ theme }) => theme.font.size0};
  font-weight: ${({ theme }) => theme.font.weightMedium};
  line-height: 1.375;
  margin-bottom: 4px;
`;

export const SubHeading = styled.div`
  color: ${({ theme }) => theme.color.text2};
  font-size: ${({ theme }) => theme.font.size1};
  font-weight: ${({ theme }) => theme.font.weightMedium};
  line-height: 1.375;
  margin-bottom: 4px;
`;

export const Paragraph = styled.div`
  color: ${({ theme }) => theme.color.text3};
  font-size: ${({ theme }) => theme.font.size1};
  font-weight: ${({ theme }) => theme.font.weightNormal};
  line-height: 1.375;
  margin-bottom: 16px;
`;

export const Tertiary = styled.div`
  color: ${({ theme }) => theme.color.text3};
  font-size: ${({ theme }) => theme.font.size2};
  font-weight: ${({ theme }) => theme.font.weightNormal};
  line-height: 1.375;
`;

export const Form = styled.form<{ horizontal?: boolean }>`
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  ${({ horizontal }) =>
    horizontal &&
    css`
      flex-direction: row;
    `}
`;

export const FormControl = styled.div<{ horizontal?: boolean }>`
  width: fit-content;
  display: flex;
  flex-direction: ${({ horizontal }) => (horizontal ? 'row' : 'column')};
  margin: ${({ theme }) =>
    `0 ${unitCalc(theme.baseline, 2, '/')} ${unitCalc(
      theme.baseline,
      2,
      '/'
    )} 0`};
`;

export const StyledFormContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledPanel = styled.div`
  width: 50%;
  margin: 0.5rem;
  padding: 0.8rem;
  border: 1px solid ${({ theme }) => theme.color.border3};
`;

export const StyledCalciteLabel = styled(CalciteLabel)`
  min-width: 8em;
`;

export const StyledCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1rem auto;
  gap: ${({ theme }) => theme.baseline};
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    margin-top: 1.55rem;
  }
  to {
    opacity: 1;
    margin-top: 0;
  }
`;

export const StyledActiveCard = styled(CalciteCard)`
  flex: 1 0 100px;
  cursor: pointer;
  transition: box-shadow 175ms cubic-bezier(0.4, 0, 0.2, 1);
  animation: ${fadeIn} 475ms forwards cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.08) 0px 3px 10px,
      rgba(0, 0, 0, 0.12) 0px 3px 10px, 0 0 0 1px rgba(0, 0, 0, 0.1),
      0 0 16px 0 rgba(0, 0, 0, 0.05);
  }
`;

const SelectedCardStyles = css`
  box-shadow: #48e2cb 0px 3px 10px, #48e2cb 0px 3px 10px, 0 0 0 1px #48e2cb,
    0 0 16px 0 #48e2cb;
`;

const DefaultCardStyles = css`
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 0 16px 0 rgba(0, 0, 0, 0),
    0 0 0 1px rgba(0, 0, 0, 0.1), 0 0 16px 0 rgba(0, 0, 0, 0);
`;

export const StyledPassiveCard = styled(CalciteCard)`
  align-items: center;
  flex: 1 0 100px;
  ${props => (props.selected ? SelectedCardStyles : DefaultCardStyles)};
  transition: box-shadow 175ms cubic-bezier(0.4, 0, 0.2, 1);
  animation: ${fadeIn} 475ms forwards cubic-bezier(0.4, 0, 0.2, 1);
`;

export const StyledCardTitle = styled(Heading)`
  text-align: center;
  margin-bottom: 1.5rem;
`;

export const StyledCardText = styled(Paragraph)`
  text-align: center;
  margin-bottom: 0;
`;
